
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import YetkiliBilgiSection from "../../load/mainSections/YetkiliBilgiSection"
import Btn from "../../shared/button/Btn"
import { teklifKabul, updateRouteData } from "../../../features/loadList/loadListSlice"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            width: 100%;
            display: flex;
            height: 100%;
            padding: 40px;
            overflow-x: auto;
            flex-direction: column;
            p{
                font-weight: var(--font-weight-md);
            }
        
        }

        .btn-container{
            width: 100%;
            height: 70px;
            margin: 0 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 40px;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
        }
    }
`

const LoadYetkiliBilgiFormInfoModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {processedUserId, isLoadingTeklifKabul, loadItemData } = useSelector(state => state.loadList)

    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <Container>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Yetkili Bilgileri Bilgilendirme"}/>
            <div className="content">
                <p>Teklifi onaylamak için lütfen yükleme ve boşaltma noktalarına ait yetkili bilgilerini doldurunuz.</p>
                <br/>
                <p>Bu bilgiler yükleme ve boşaltma bilgilerini sürücülere göstermek, sms onaylı teslimat için kullanılacaktır.</p>
            </div>
            <div className="btn-container">
                <Btn bgColor="#fff" color="#E85446" borderColor="#E85446" width={"220px"} handleClick={() => dispatch(showModal("loadYetkiliBilgiForm"))}>Bilgilere Git</Btn>
                <Btn bgColor="#E85446" color="#fff" borderColor="transparent" width={"220px"} handleClick={() => {dispatch(teklifKabul({id: processedUserId, createdUserId: loadItemData?.createrUserId}))}}>{(isLoadingTeklifKabul && processedUserId) ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"} /> : "Teklifi Onayla"}</Btn>
            </div>
        </div>
    </Container>
  )
}

export default LoadYetkiliBilgiFormInfoModal